import React from "react";
import { Icon } from "../../components/core/Icon";
import { Add } from "../../components/Add";

import styles from "../../../styles/catalog.module.scss";
import { ProductItem } from "./ProductItem";

import classNames from "classnames/bind";
import { Badge } from "@components";
const css = classNames.bind(styles)

export const CategoryItem = ({ category, readOnly, onEditCategory, onProductOrdination, onAddProduct, onEditProduct }) => {
    return (
        <div className={css({ category: true, hidden: !category.show })}>
            <div className={styles.header}>
                <div className="d-flex align-center">
                    <p className={styles.name}>{category.name}</p>
                    {!category.show && <Badge name="Oculto" type="danger" absolute={false} />}
                </div>
                <div className="d-flex align-center">
                    <span className="pointer" onClick={() => onEditCategory && onEditCategory(category)} >
                        <Icon name="pen" size="sm" />
                    </span>
                    <span
                        className="pointer ml-20" onClick={() => onProductOrdination && onProductOrdination(category)} >
                        <Icon name="sort-size-up" size="sm" />
                    </span>
                </div>
            </div>
            <div className={styles.products}>
                {category.items.map((item, index) => {
                    return item.visible && (
                       <ProductItem 
                            key={index}
                            product={item}
                            onEditProduct={onEditProduct}
                       />
                    );
                })}
                { readOnly === false && (
                    <Add
                        text="Adicionar produto"
                        className="flex-column"
                        style={{ minHeight: 180 }}
                        onClick={() => onAddProduct && onAddProduct(category)}
                    />
                )}

            </div>
        </div>
    )
}